import React, { useState } from 'react';
import './Service.css';
import AppBar from "../atoms/AppBar";
import data from '../../Data/jsons/service.json';

const Service = () => {
	const { talks, committeeData } = data;
	const [activeTab, setActiveTab] = useState('committee');

	// Count total for tab display
	const totalCommittee = committeeData.reduce((acc, yearData) => {
		return acc + (yearData.conference?.length || 0) + (yearData.journal?.length || 0) + (yearData.workshop?.length || 0);
	}, 0);

	return (
		<div className="service-page">
			<AppBar />

			<div className="service-main-content">
				<header className="service-header">
					<div className="hero-text">
						<h1 className="hero-title">Service</h1>
						<p className="hero-subtitle">
							Contributions through peer review and invited talks.
						</p>
					</div>
				</header>

				<div className="filters-bar">
					<div className="filter-tabs">
						<button
							className={`filter-tab ${activeTab === 'committee' ? 'active' : ''}`}
							onClick={() => setActiveTab('committee')}
						>
							Committee & Reviewing
							<span className="tab-count">{totalCommittee}</span>
						</button>
						<button
							className={`filter-tab ${activeTab === 'talks' ? 'active' : ''}`}
							onClick={() => setActiveTab('talks')}
						>
							Invited Talks
							<span className="tab-count">{talks.length}</span>
						</button>
					</div>
				</div>

				<section className="service-list-section">
					{activeTab === 'committee' && (
						<div className="committee-by-year">
							{committeeData.map((yearData) => (
								<div key={yearData.year} className="year-section">
									<div className="year-header">
										<span className="year-label">{yearData.year}</span>
									</div>
									<div className="year-entries">
										{yearData.conference && yearData.conference.map((item, idx) => (
											<div key={`conf-${idx}`} className="service-card">
												<div className="service-card-header">
													<span className="service-type">Conference</span>
												</div>
												<div className="service-card-main">
													<h3 className="service-name">{item.name}</h3>
													{item.link && (
														<a href={item.link} target="_blank" rel="noopener noreferrer" className="service-link">
															Visit →
														</a>
													)}
												</div>
											</div>
										))}
										{yearData.journal && yearData.journal.map((item, idx) => (
											<div key={`jour-${idx}`} className="service-card">
												<div className="service-card-header">
													<span className="service-type journal">Journal</span>
												</div>
												<div className="service-card-main">
													<h3 className="service-name">{item.name}</h3>
													{item.link && (
														<a href={item.link} target="_blank" rel="noopener noreferrer" className="service-link">
															Visit →
														</a>
													)}
												</div>
											</div>
										))}
										{yearData.workshop && yearData.workshop.map((item, idx) => (
											<div key={`work-${idx}`} className="service-card">
												<div className="service-card-header">
													<span className="service-type workshop">Workshop</span>
												</div>
												<div className="service-card-main">
													<h3 className="service-name">{item.name}</h3>
													{item.link && (
														<a href={item.link} target="_blank" rel="noopener noreferrer" className="service-link">
															Visit →
														</a>
													)}
												</div>
											</div>
										))}
									</div>
								</div>
							))}
						</div>
					)}

					{activeTab === 'talks' && (
						<div className="talks-list">
							{talks.map((talk, idx) => (
								<div key={idx} className="talk-card">
									<div className="talk-sidebar">
										<span className="talk-year">{talk.year}</span>
									</div>
									<div className="talk-main">
										<p className="talk-description">{talk.description}</p>
									</div>
								</div>
							))}
						</div>
					)}
				</section>
			</div>
		</div>
	);
};

export default Service;
